import Repository from './Repository';

const resource = "/notifications";
export default {
    all() {
        return Repository.get(`${resource}/`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    create(payload) {
        return Repository.post(`${resource}/`, payload);
    },
    markAsRead(id) {
        return Repository.post(`${resource}/${id}/mark_read/`);
    },
    markAllAsRead() {
        return Repository.post(`${resource}/mark_all_read/`);
    },
    getUnreadCount() {
        return Repository.get(`${resource}/unread_count/`);
    },
    getStreamUrl() {
        return `${Repository.defaults.baseURL}${resource}/stream/`;
    },
    getStreamToken() {
        return Repository.post(`${resource}/get_stream_token/`);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}/`);
    }
}
